









































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";


/**
 * Character cell component.
 */
@Component
export default class CharacterCell extends Vue {
	// Injections
	imageLinks = imageLinks;
	classes = classes;

	@Prop({required: true})
	character!: {
		userPremiumLevel: number;
		class: string;
		thumbnail: string | null;
		name: string;
	};

	@Prop()
	note!: string | null;

	@Prop({type: Boolean, default: false})
	simple!: boolean;

	@Prop({type: Boolean, default: false})
	hideIcon!: boolean;
}
